import { DynamicService } from 'utils/service';

import {
  API_USER_EMPLOYEE_PROFILE_PERMISSION_WHATSAPP_CONTENTS,
  UserEmployeeProfilePermissionWhatsAppContentBulkInput,
} from './models';

export * from './models';

class Service extends DynamicService<Components.Schemas.UserEmployeeProfilePermissionWhatsAppContent> {
  createBulk = async (data: UserEmployeeProfilePermissionWhatsAppContentBulkInput) => {
    return this.engine.post(API_USER_EMPLOYEE_PROFILE_PERMISSION_WHATSAPP_CONTENTS.INSERT_BULK, {
      mainID: data.whatsappContentID,
      itemIDs: data.userEmployeeProfilePermissionIDs,
    });
  };
}

export const ServiceUserEmployeePermissionWhatsAppContents = new Service({
  mainField: 'id',
  getAll: API_USER_EMPLOYEE_PROFILE_PERMISSION_WHATSAPP_CONTENTS.GET_ALL_DYNAMIC,
  post: API_USER_EMPLOYEE_PROFILE_PERMISSION_WHATSAPP_CONTENTS.POST,
  delete: API_USER_EMPLOYEE_PROFILE_PERMISSION_WHATSAPP_CONTENTS.DELETE,
  patch: API_USER_EMPLOYEE_PROFILE_PERMISSION_WHATSAPP_CONTENTS.PATCH,
});
